import { Children, Component } from 'react'
import PropTypes from 'prop-types'

export default class OnEscape extends Component {
    constructor() {
        super()
        this.onEscape = this.onEscape.bind(this)
    }

    componentDidMount() {
        document.addEventListener('keydown', this.onEscape)
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onEscape)
    }

    onEscape({ keyCode }) {
        if (keyCode === 27) {
            this.props.onEscape()
        }
    }

    render() {
        return Children.only(this.props.children)
    }
}

OnEscape.propTypes = {
    onEscape: PropTypes.func.isRequired,
    children: PropTypes.node,
}



// WEBPACK FOOTER //
// ./src/utils/OnEscape.js